import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  Filter,
  ReferenceInput,
  SelectInput,
  ChipField,
  ReferenceArrayInput,
  SelectArrayInput,
  DateField,
  DateInput,
  TextInput,
  SelectField
} from "react-admin";
import Actions from '../Actions'

const GroupFilter = props => {
  return (
    <Filter {...props}>
      <TextInput label="Name" source="name_contains" />
    </Filter>
  );
};

export const GroupList = props => {
  // const role = localStorage.getItem('role')
  // const project = JSON.parse(localStorage.getItem('project'))
  // const filter = role ? role === SUPERADMIN ? {} : { project } : { project }
  return (
    <List
      {...props}
      title="group.group"
      actions={<Actions create />}
      bulkActions={false}
      filters={<GroupFilter />}
    // sort={{ field: 'createdAt', order: 'DESC' }}
    // filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="name" />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/group/GroupList.js